import { useIsomorphicLayoutEffect } from '@cian/react-utils';

import { useState } from 'react';

import { type IEventEmitter } from 'shared/services/eventEmitter';

export type TUseBannerLoadingStateParams = {
  eventEmitter: IEventEmitter;
};

/**
 * Возвращает признак того, что баннер ещё грузится.
 *
 * Скелетон висит до события `load` в EventEmitter. На `stub`/`error` его тоже
 * снимаем — в этих случаях `load` не наступит и скелетон бы висел вечно.
 */
export function useBannerLoadingState({ eventEmitter }: TUseBannerLoadingStateParams): boolean {
  const [isLoading, setIsLoading] = useState(true);

  useIsomorphicLayoutEffect(() => {
    const stopLoading = (): void => setIsLoading(false);

    const unsubscribes = [
      eventEmitter.subscribe('load', stopLoading),
      eventEmitter.subscribe('stub', stopLoading),
      eventEmitter.subscribe('error', stopLoading),
    ];

    return (): void => {
      unsubscribes.forEach(unsubscribe => unsubscribe());
    };
  }, [eventEmitter]);

  return isLoading;
}
